import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../UI/Loader';
import JobAssignmentsTable from './JobAssignmentsTable';
import JobAssignmentsFilters from './JobAssignmentsFilters';
import { TableWrapper, NoResultText } from './SharedStyledComponents';
import { useJobAssignments } from '../../hooks/useJobAssignments';

const JobAssignmentsOverview = () => {
    const [t] = useTranslation();

    const {
        loading,
        filterOptionsLoading,
        assignments,
        pagination,
        filterOptions,
        filters,
        handleFormChange,
        handleSort,
        handlePageChange,
        refetch,
    } = useJobAssignments();

    // Prepare assignments data for job filtering
    const allAssignmentsData = assignments.map(assignment => ({
        job_title: assignment.job_title,
        job_company_name: assignment.job_company_name
    }));

    return (
        <>
            <JobAssignmentsFilters
                filterOptions={filterOptions}
                filterOptionsLoading={filterOptionsLoading}
                onFilter={handleFormChange}
                filters={filters}
                allAssignmentsData={allAssignmentsData}
            />

            <TableWrapper>
                <Loader spinning={loading}>
                    {!loading && assignments.length === 0 ? (
                        <NoResultText>{t('NO_ASSIGNMENTS_FOUND', 'No job assignments found')}</NoResultText>
                    ) : (
                        <>
                            {filters.aggregateByCompany && (
                                <div style={{
                                    padding: '0.5rem 1rem',
                                    backgroundColor: '#f6f8fa',
                                    borderRadius: '4px',
                                    marginBottom: '1rem',
                                    fontSize: '0.875rem',
                                    color: '#627d95'
                                }}>
                                </div>
                            )}
                            <JobAssignmentsTable
                                assignments={assignments}
                                pagination={pagination}
                                onSort={handleSort}
                                onPageChange={handlePageChange}
                                currentSort={filters.sort}
                                onAssignmentRemoved={refetch}
                                isAggregated={filters.aggregateByCompany}
                            />
                        </>
                    )}
                </Loader>
            </TableWrapper>
        </>
    );
};

export default JobAssignmentsOverview; 